<template>
    <section>
        <ds-modal
            :is-open="isNotesModalOpen"
            :title.sync="fullName"
            :size="modalSize"
            class="regular-modal"
            show-back
            @back="isNotesModalOpen = false"
        >
            <div class="popup-div">
                <div class="note-header">
                    <div class="popup-div-notes">
                        Notes
                    </div>
                    <div class="add-button-dropdown">
                        <ds-dropdown
                            class="dropdown"
                            position="bottom-end"
                        >
                            <ds-filled-button trailing-icon="chevron-down">
                                Add a note
                            </ds-filled-button>

                            <div slot="menu">
                                <div
                                    class="dropdown-menu-item"
                                    @click="showAddNotesModal"
                                >
                                    <ds-icon class="add-icon" name="add-fill" />
                                    <div class="add-a-note-label">
                                        Add a note
                                    </div>
                                </div>
                                <div v-if="contactPermissionDTO.canUseActivityHistoryTemplates">
                                    <div class="note-from-template">
                                        Add a note from template
                                    </div>

                                    <ul
                                        v-for="temp in templateObject"
                                        :key="temp.value"
                                        class="notes-dropdown-menu-list"
                                        @click="saveFromTemplate(temp.value)"
                                    >
                                        <li class="dropdown-menu-item">
                                            {{ temp.label }}
                                        </li>
                                    </ul>
                                </div>
                                <div
                                    slot="footer"
                                    class="footer"
                                    @click="viewMangeNotesTemplate"
                                >
                                    <a>Manage note templates</a>
                                </div>
                            </div>
                        </ds-dropdown>
                    </div>
                </div>
                <div>
                    <div v-if="isContactHasAllNotes" class="notes-details">
                        <ds-table-grid
                            ref="table"
                            :data="allNotes"
                            align="center"
                            :sort-field="sortField"
                            :sort-ascending="sortAscending"
                            @sort="sortTable"
                        >
                            <ds-table-grid-column label="Title" width="100">
                                <template slot-scope="note">
                                    <div @click="editNotesModal(note)">
                                        <span class="note-title">{{
                                            note.title
                                        }}</span>
                                    </div>
                                </template>
                            </ds-table-grid-column>

                            <ds-table-grid-column label="Description" width="100">
                                <template slot-scope="note">
                                    <div @click="editNotesModal(note)">
                                        <span
                                            v-if="note.contents"
                                            class="note-description"
                                        >{{ note.contents }}</span>
                                        <span v-else class="note-description">
                                            -
                                        </span>
                                    </div>
                                </template>
                            </ds-table-grid-column>

                            <ds-table-grid-column label="Assigned to" width="50">
                                <template slot-scope="note">
                                    <div @click="editNotesModal(note)">
                                        <span class="notes-assigne">{{
                                            getAssignName(note.assignedTo)
                                        }}</span>
                                    </div>
                                </template>
                            </ds-table-grid-column>

                            <ds-table-grid-column
                                prop="lastUpdated"
                                label="Last updated"
                                width="50"
                                sortable
                            >
                                <template slot-scope="note">
                                    <div @click="editNotesModal(note)">
                                        <span>{{
                                            dateFormatDate(
                                                note.lastUpdated,
                                                "MMM D, YYYY"
                                            )
                                        }}</span>
                                    </div>
                                </template>
                            </ds-table-grid-column>
                        </ds-table-grid>
                    </div>
                </div>
            </div>
        </ds-modal>
        <notes-form
            ref="notesModal"
            :note-dropdowns="noteDropdowns"
            :contact="contact"
            :user-id="userId"
        />
    </section>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import NotesForm from './NotesForm';

export default {
    components: {
        NotesForm,
    },

    props: {
        contact: Object,
        notesCount: [String, Number],
        userId: [String, Number],
        noteDropdowns: Object,
    },

    data() {
        return {
            allNotes: [],
            options: {},
            modalSize: 'fullscreen',
            templateObject: [],
            sortAscending: false,
            sortField: 'lastUpdated',
            contactPermissionDTO: {},
            isNotesModalOpen: false,
        };
    },

    created() {
        this.$root.$on('CONTACTPERMISSIONS', (contactPermissions) => {
            this.contactPermissionDTO = contactPermissions;
        });
    },

    mounted() {
        this.$root.$on('DROPDOWN_LOADED', (dropDownData) => {
            this.options = dropDownData;
        });
        this.$root.$on('NOTES_STATUS_POPUP', (data) => {
            if (data) {
                this.showAllNotesModal();
            }
        });
    },

    beforeDestroy() {
        this.$root.$off('DROPDOWN_LOADED');
        this.$root.$off('NOTES_STATUS_POPUP');
    },

    computed: {
        fullName() {
            return `${this.contact.firstName} ${this.contact.lastName}`;
        },

        isContactHasAllNotes() {
            return this.allNotes && this.allNotes.length > 0;
        },
    },

    methods: {
        showAddNotesModal() {
            this.$refs.notesModal.showModal(null, true);
        },

        async saveFromTemplate(tempId) {
            try {
                await axios.post(`/app/note/saveFromTemplateField/${tempId}/${this.contact.id}`);

                const successMessage = 'Note added from template';

                this.$toast({ message: successMessage });
                this.$root.$emit('NOTES_STATUS', true);
                this.$root.$emit('NOTES_STATUS_POPUP', true);
            } catch (error) {
                this.$error({
                    message: 'error occurred while saving the note form template',
                });
            }
        },

        viewMangeNotesTemplate() {
            window.open('/SystemTemplate/manageTemplate.jsp?view=add&master=true&TemplateKind=Note');
        },

        async showAllNotesModal() {
            try {
                const response = await axios.get(`/app/note/loadAllNotes/${this.contact.id}/${this.notesCount}`);

                this.allNotes = response.data.notesDetailsList;
            } catch (error) {
                this.$error({
                    message: 'error occurred while getting all note',
                });
            }
            this.isNotesModalOpen = true;
            const templateDrop = this.noteDropdowns.templateList;

            this.templateObject = Object.keys(templateDrop)
                .map((key) => {
                    return { label: templateDrop[key], value: Number(key) };
                })
                .sort((prev, next) => prev.label.localeCompare(next.label));

            this.sortAscending = false;
        },

        getAssignName(assignId) {
            const owner = this.options.owners && this.options.owners.find((user) => user.value === assignId);

            return owner && Object.values(owner)[0] ? Object.values(owner)[0] : '';
        },

        dateFormatDate(date, format = 'll') {
            const formattedDate = moment(date).isValid() ? date : new Date(date);

            return moment(formattedDate).format(format);
        },

        editNotesModal(note) {
            this.$refs.notesModal.showModal(note, true);
        },

        sortTable({ ascending }) {
            const factor = ascending === true ? -1 : 1;

            this.sortAscending = ascending;
            this.allNotes = this.allNotes.sort((prev, next) => {
                if (prev.lastUpdated > next.lastUpdated) return -1 * factor;
                if (prev.lastUpdated < next.lastUpdated) return 1 * factor;

                return 0;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.notes-assigne {
    font-size: px-to-rem(14px);
}

.notes-details {
    cursor: pointer;
}

.note-title {
    text-overflow: ellipsis;
    overflow-x: hidden;
    white-space: nowrap;
    display: table-caption;
    width: 16rem;
}

.note-description {
    text-overflow: ellipsis;
    overflow-x: hidden;
    white-space: nowrap;
    display: table-caption;
    width: 16rem;
}

.popup-div {
    margin-left: 12rem;
    margin-right: $spacing-600;
}

.popup-div-notes {
    font-size: $font-size-jumbo;
}

.add-icon {
    color: $color-blue;
}

.add-a-note-label {
    margin-left: $spacing-100;
}

.note-from-template {
    color:  $color-gray;
    margin-left: $spacing-200;
    text-align: left;
}

.footer {
    position: sticky;
    bottom: 0;
    background-color: $color-white;
    height: 3.5rem;
}

.notes-dropdown-menu-list {
    padding: 0.01rem 0;
}

@media only screen and ($small) {
    .popup-div {
        margin-left: $spacing-050;
        margin-right: $spacing-100;
    }
}

.note-header {
    justify-content: space-between;
    display: flex;
    margin-bottom: $spacing-200;
}

.add-button-dropdown {
    text-align: right;
    --dropdown-height: #{px-to-rem(330px)};
}
</style>
